import { render, staticRenderFns } from "./policyation.vue?vue&type=template&id=740d6dcc&scoped=true&"
import script from "./policyation.vue?vue&type=script&lang=js&"
export * from "./policyation.vue?vue&type=script&lang=js&"
import style0 from "./policyation.vue?vue&type=style&index=0&id=740d6dcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740d6dcc",
  null
  
)

export default component.exports